<template>
  <b-modal :id="`ModalDuplicarCenario${id}`">
    <Header mini titulo="DUPLICAR CENÁRIO" icone="copy" cor="azul" slot="modal-header"/>
    <template>
      <div class="modal-corpo">
        Gostaria de duplicar o cenário principal para o novo cenário
      </div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="duplicar"
        icone="check"
        :click="handleClick"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

export default {
  name: "ModalDuplicar",
  components: {
    BotaoPadrao,
    Header
  },
  props: {
    dadosForm: Object,
    nomeCenario: String,
    ncmLabel: String,
    numeroCenarios: Number,
    numeroNomeCenario: Number,
    id: Number
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  methods: {
    ...mapActions("cenario", ["selectCenario"]),
    handleKey(event) {
      let modal = document.getElementById(`ModalDuplicarCenario${this.id}`);
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.submitDuplicarCenario();
          this.$root.$emit("bv::hide::modal", `ModalDuplicarCenario${this.id}`);
        }
      }
    },
    handleClick() {
      this.submitDuplicarCenario();
      this.$root.$emit("bv::hide::modal", `ModalDuplicarCenario${this.id}`);
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", `ModalDuplicarCenario${this.id}`);
    },
    submitDuplicarCenario() {
      let data = {
        nome_cenario: `${this.nomeCenario} (${this.numeroNomeCenario})`,
        ncm: this.dadosForm.ncm,
        ncmLabel: this.ncmLabel,
        ex: this.dadosForm.ex,
        id_local_operacao: this.dadosForm.tipoOperacao,
        id_estado_origem: this.dadosForm.ufOrigem,
        id_estado_destino: this.dadosForm.ufDestino,
        id_pais_origem: this.dadosForm.paisOrigem,
        id_pais_destino: this.dadosForm.paisDestino,
        cnpj_remetente: this.dadosForm.cnpjRemetente,
        cnpj_destinatario: this.dadosForm.cnpjDestinatario,
        id_remetente_regime: this.dadosForm.regimeRemetente,
        id_remetente_atividade: this.dadosForm.atividadeRemetente,
        id_remetente_tipo_atividade: this.dadosForm.tipoAtividadeRem,
        id_destinatario_regime: this.dadosForm.regimeDestinatario,
        id_destinatario_atividade: this.dadosForm.atividadeDestino,
        id_destinatario_tipo_atividade: this.dadosForm.tipoAtividade,
        id_origem: this.dadosForm.origem,
        id_destinacao: this.dadosForm.destinacao,
        cnae_remetente: this.dadosForm.cnaeRemetente,
        cnae_destinatario: this.dadosForm.cnaeDestinatario,
        zfm: this.dadosForm.zfm,
        sn_rbt12: this.dadosForm.sn_rbt12,
        sn_rba: this.dadosForm.sn_rba,
        sn_rm: this.dadosForm.sn_rm,
        idCenario: this.numeroCenarios,
        sabeCNPJDestinatario: this.dadosForm.sabeCNPJDestinatario
      };
      this.$nextTick(() => {
        this.selectCenario(data);
      });
    }
  }
};
</script>

<style lang="scss">
.modal-cabecalho {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center;
}
.modal-cabecalho-interno {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal-icone-duplicar {
  font-size: 40px;
  margin: 5px 0;
  color: var(--azul2);
}
.modal-corpo {
  text-align: center;
}
.botao-modal {
  margin: 0 0 0 10px !important;
}
</style>
